import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaBullseye, FaChartBar, FaLightbulb } from "react-icons/fa";
//import "./ViewPromotion.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import { hitPromotionDetailsProfessionalApi } from "../../../../Redux/Professional/PromotionDetailsProfessionalSlice";
import { hitPromotionUpdateApi } from "../../../../Redux/Professional/UpdatePromotionSlice";
import moment from "moment";
import { showToast } from "../../../../Helper/Toast";

const ViewPromotion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = React.useState(true);
  const [progress, setProgress] = React.useState(0);
  const [promotionData, setPromotionData] = React.useState(null);
  const [selectedPromotionId, setSelectedPromotionId] = useState(null);

  const [showDeletePromotionModal, setShowDeletePromotionModal] =
    useState(false);
  const promotionDetails = useSelector(
    (state) => state.promotionDetailsProfessionalReducer.data
  );

  const campaignId = location?.state?.campaignId;
  useEffect(() => {
    if (!campaignId) {
      showToast("Promotion not found", "error");
      navigate("/professional/campaigns");
      return;
    }
    dispatch(hitPromotionDetailsProfessionalApi({ promotionId: campaignId }));
  }, [dispatch, campaignId, navigate]);

  useEffect(() => {
    if (promotionDetails?.status === true) {
      setLoading(false);
      setPromotionData(promotionDetails.data);
      const startDate = moment(promotionDetails.data?.createdAt);
      const endDate = moment(promotionDetails.data?.endDate);
      const now = moment();
      if (startDate.isValid() && endDate.isValid()) {
        const totalDays = endDate.diff(startDate, "days");
        const daysPassed = now.diff(startDate, "days");
        //console.log("Days Passed:", daysPassed);
        //console.log("Total Days:", totalDays);
        let progress = 0;
        if (totalDays > 0) {
          progress = Math.min(Math.max((daysPassed / totalDays) * 100, 0), 100);
          setProgress(parseInt(progress));
        }
      }
    }
  }, [promotionDetails]);

  const updatePromotion = (status) => {
    // Implement pause functionality here
    setLoading(true);
    //console.log("Updating promotion status to:", status);

    dispatch(
      hitPromotionUpdateApi({ promotionId: campaignId, status: status })
    ).then((response) => {
      setLoading(false);
      if (response.payload.status === true) {
        if (status === 1) {
          showToast("Campaign resumed successfully", "success");
          dispatch(
            hitPromotionDetailsProfessionalApi({ promotionId: campaignId })
          );
        } else {
          showToast("Campaign paused successfully", "success");
          dispatch(
            hitPromotionDetailsProfessionalApi({ promotionId: campaignId })
          );
        }
       // navigate("/professional/campaigns");
        handleViewDetails();
      }
    });
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = () => {
    // Dispatching the delete API call
    setLoading(true);
    dispatch(
      hitPromotionUpdateApi({ promotionId: selectedPromotionId, isDeleted: 1 })
    )
      .then((response) => {
        setLoading(false);
        if (response?.payload?.status === true) {
          setShowDeletePromotionModal(false);
          showToast(response.payload.message, "success");
          navigate("/professional/campaigns");
        } else {
          setLoading(false);
          showToast(response.error.message, "error");
        }
      })
      .catch((error) => {
        setLoading(false);
        // Optionally handle any errors that happen during the dispatch
        console.error("Error in deletion:", error);
        showToast("There was an error processing your request.", "error");
      });
  };


  if (loading) {
    return (
      <div style={{ height: "100vh" }}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="campaign-dashboard pro-app-page">
      <div className="custom_container">
        <Row>
          <Col lg={7}>
            <div className="promotion-section">
              <div className="promotion-header">
                <div className="avatar">
                  <img
                    className="avatar"
                    src={promotionData?.professionalId?.companyLogo}
                    alt="Company Logo"
                  />
                </div>
                <div className="promotion-info">
                  <h2>{promotionData?.professionalId?.companyName}</h2>
                  <p className="rating">
                    ⭐ {promotionData?.professionalId?.overAllStarRating} •{" "}
                    {promotionData?.professionalId?.reviewCount} Reviews
                  </p>
                </div>
              </div>
              <p className="offer">{promotionData?.promotionTitle}</p>
              <p className="desc">{promotionData?.promotionDescription}</p>
              <span className="badge-1">{promotionData?.serviceIds?.name}</span>

              <p className="offer mt-3">Media</p>
              <div className="media-gallery">
                {promotionData?.media?.map((item, index) => (
                  <div className="media-card">
                    <img src={item} alt="house" />
                  </div>
                ))}
              </div>
              {/* // 1- Amount per sq foot, 2- percentage, 3- fixed amount */}
              <span className="badge">
                {promotionData?.discountType === 1
                  ? "$" + promotionData?.discountValue + " off /sq ft"
                  : promotionData?.discountType === 2
                  ? promotionData?.discountValue + "% off"
                  : "$" + promotionData?.discountValue + " off"}
              </span>
            </div>

            <div className="timeline-performance mt-4">
              <div className="campaign-timeline">
                <h2>{promotionData?.professionalId?.companyName}</h2>
                <p className="calander">
                  {moment(promotionData?.createdAt).format("MM/DD/YYYY")} -{" "}
                  {moment(promotionData?.endDate).format("MM/DD/YYYY")}
                </p>
                <p className="timeing">
                  {moment(promotionData?.endDate).diff(moment(), "days") + 1}{" "}
                  remaining days
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <p className="remaning_day">Campaign Progress</p>
                  <h6>{progress}% Complete</h6>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                {/* <p className="offer mt-3"> Daily Performance (Last 5 Days)</p>
                <table className="performance-table">
                  <thead>
                    <tr>
                      <th colSpan={4}>Jan 15</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>12</span>
                        <br />
                        Views
                      </td>
                      <td>
                        <span>2</span>
                        <br />
                        Leads
                      </td>
                      <td>
                        <span>0</span>
                        <br />
                        Jobs
                      </td>
                      <td>
                        <span>5 credits</span>
                        <br />
                        Spent
                      </td>
                    </tr>
                  
                  </tbody>
                </table> */}
              </div>
            </div>
          </Col>

          <Col lg={5}>
            <div className="sidebarss">
              <div className="top_btn">
                <h6>Campaign Control</h6>
                <div className="campaign-control">
                  <button
                    className="pause"
                    onClick={() =>
                      updatePromotion(promotionData.status === 1 ? 2 : 1)
                    }
                  >
                    {promotionData.status === 1
                      ? "⏸ Pause Campaign"
                      : "▶️ Resume Campaign"}
                  </button>
                  <button
                    className="edit"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/professional/edit-campaign", {
                        state: { campaignId: campaignId },
                      });
                    }}
                  >
                    ✏️ Edit Campaign
                  </button>
                </div>
              </div>

            </div>

            <div className="sidebar-card campaign-actions-card">
              <div className="card-header">
                <div className="icon-wrapper purple">
                  <FaBullseye />
                </div>
                <h4>Campaign Actions</h4>
              </div>
              <div className="actions-list-new">
                <div className="action-card blue-bg">
                  <FaChartBar className="action-card-icon" />
                  <div className="action-card-content">
                    <h5>View Analytics</h5>
                    <p>Detailed performance report</p>
                  </div>
                </div>
                <div
                  className="action-card green-bg"
                  onClick={() =>
                    navigate(`/professional/edit-campaign`, {
                      state: { campaignId: campaignId },
                    })
                  }
                >
                  <FaChartBar className="action-card-icon" />
                  <div className="action-card-content">
                    <h5>Boost Campaign</h5>
                    <p>
                      Consider pausing low-performing campaigns and reallocating
                      budget
                    </p>
                  </div>
                </div>
                <div
                  className="action-card yellow-bg"
                  onClick={() =>
                    navigate(`/professional/edit-campaign`, {
                      state: { campaignId: campaignId },
                    })
                  }
                >
                  <FaLightbulb className="action-card-icon" />
                  <div className="action-card-content">
                    <h5>Edit Campaign</h5>
                    <p>
                      Consider pausing low-performing campaigns and reallocating
                      budget
                    </p>
                  </div>
                </div>
                <div
                  className="action-card red-bg"
                  onClick={() => {
                    setShowDeletePromotionModal(true);
                    setSelectedPromotionId(campaignId);
                  }}
                >
                  <FaLightbulb className="action-card-icon" />
                  <div className="action-card-content">
                    <h5>Delete Campaign</h5>
                    <p>
                      Consider pausing low-performing campaigns and reallocating
                      budget
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {showDeletePromotionModal && (
        <div className="modal-overlay">
          <div className="withdraw-modal">
            <div className="withdraw-icon">⚠️</div>
            <p className="withdraw-message">
              Campaign Delete?
              <br />
              Are you sure to delete the campaign?
            </p>
            <div className="modal-actions">
              <button className="confirm-btn" onClick={() => handleDelete()}>
                Confirm
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowDeletePromotionModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewPromotion;
